import { useToasts } from '../state/toast';

export function Toasts() {
  const { toasts, dismiss } = useToasts();
  return (
    <div className="toasts" role="status" aria-live="polite">
      {toasts.map((t) => (
        <div key={t.id} className={`toast ${t.kind}`} data-testid="toast">
          <div className="grow">
            {t.text}
            {t.action && (
              <div className="toast-actions">
                <button
                  type="button"
                  className="btn small primary"
                  onMouseDown={(e) => e.preventDefault()}
                  onClick={() => {
                    dismiss(t.id);
                    t.action!.run();
                  }}
                  data-testid="toast-action"
                >
                  {t.action.label}
                </button>
              </div>
            )}
          </div>
          <button className="btn ghost small" onClick={() => dismiss(t.id)} aria-label="Schließen">
            ✕
          </button>
        </div>
      ))}
    </div>
  );
}
